import { useLocation, useNavigate } from "react-router-dom";
import {
  GraduationCap,
  FolderOpen,
  Video,
  Plus,
  BarChart,
  UserPlus, Settings, UserCheck
} from "lucide-react";
import { useTranslation } from 'react-i18next';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentPath = location.pathname;
  const handleNavigation = (path) => {
    navigate(path);
  }
  return (
    <aside role="navigation"
      aria-label="Admin sidebar" className="bg-white border-r admin-nav">
      <div className="px-4 flex flex-col space-y-2 p-4">
        <a aria-current={`${currentPath == "/Dashboard" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 "  onClick={() => handleNavigation('/Dashboard')}>
          <BarChart size={20} /> {t("dashboard")}
        </a>
        <a aria-current={`${currentPath == "/Certifications" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 "  onClick={() => handleNavigation('/Certifications')}>
          <GraduationCap size={20} /> {t("certifications")}
        </a>
        <a aria-current={`${currentPath == "/Modules" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 " onClick={() => handleNavigation('/Modules')}>
          <FolderOpen size={20} /> {t("modules")}
        </a>
        <a aria-current={`${currentPath == "/Chapters" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 " onClick={() => handleNavigation('/Chapters')}>
          <Video size={20} /> {t("chapters")}
        </a>
        <a aria-current={`${currentPath == "/Walkthroughs" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 " onClick={() => handleNavigation('/Walkthroughs')}>
          <Video size={20} /> {t("howTo")}
        </a>
        <a aria-current={`${currentPath == "/Registrations" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 hover:text-blue-600 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 "  onClick={() => handleNavigation('/Registrations')}>
          <UserPlus size={20} /> {t("registrationsReview")}
        </a>
        <a aria-current={`${currentPath == "/UserCertifications" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 hover:text-blue-600 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 "  onClick={() => handleNavigation('/UserCertifications')}>
          <UserCheck size={20} /> {t("certificateReview")}
        </a>
        <a aria-current={`${currentPath == "/MetaData" ? "page" : ""}`} className="flex items-center gap-2 text-gray-700 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 hover:text-blue-600 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 transition-colors
 "  onClick={() => handleNavigation('/MetaData')}>
          <Settings size={20} /> {t("configurations")}
        </a>
      </div>

      <div className="p-4 mt-6 font-bold text-sm">{t("quickActions")}</div>
      <div className="flex flex-col px-4 space-y-2">
        <button aria-current={`${currentPath == "/CreateCertificate" ? "page" : ""}`} className="flex items-center gap-2 text-gray-600 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 hover:text-blue-600 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 focus:outline-none transition-colors
 " onClick={() => handleNavigation('/CreateCertificate')}>
          <Plus size={20} /> {t("addCertification")}
        </button>
        <button aria-current={`${currentPath == "/CreatedModule" ? "page" : ""}`} className="flex items-center gap-2 text-gray-600 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 hover:text-blue-600 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 focus:outline-none transition-colors
 " onClick={() => handleNavigation('/CreatedModule')}>
          <Plus size={20} />  {t("addModule")}
        </button>
        <button aria-current={`${currentPath == "/CreateChapter" ? "page" : ""}`} className="flex items-center gap-2 text-gray-600 hover:text-blue-600 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 hover:text-blue-600 aria-[current=page]:text-blue-600 aria-[current=page]:bg-gray-100 focus:outline-none transition-colors
 " onClick={() => handleNavigation('/CreateChapter')}>
          <Plus size={20} /> {t("addChapter")}
        </button>
      </div>
    </aside>
  );
}
export default AdminSidebar;